export const SWIMMING_SCHOOL_ABSENCE_COPY = {
  resignButton: "Zgłoś nieobecność",
  confirmTitle: "Czy na pewno chcesz zgłosić nieobecność?",
  confirmButton: "Tak, zgłaszam",
  loadingText: "Zgłaszanie...",
};
